export const numColWidth = 70;
export const priceColWidth = 70;
export const MOBILE_MEDIA = "@media(max-width: 767px)";
